import type { Config } from '@fanduel/cpe-um-bundle/core-config/contract';
import { Brand, Product } from '@fanduel/cpe-um-bundle/core-config/contract';
import { BRAND, COUNTRY, COUNTRY_ABBREVIATION, PRODUCT } from '../constants';
import { getRegion } from '../region/get-region';
import { getConfig } from '../config/config';

export const getBrandUM = (brand: string): Brand => {
    if (brand === BRAND.MOHEGANSUN) {
        return Brand.MoheganSun;
    }

    return Brand.FanDuel;
};

export const getCountry = (country: string) => {
    if (country === COUNTRY.CANADA) {
        return COUNTRY_ABBREVIATION.CANADA;
    }
    return COUNTRY_ABBREVIATION.USA;
};

export const getProductUM = (): any => {
    switch (process.env.PRODUCT) {
        case PRODUCT.CASINO:
            return Product.Casino;
        case PRODUCT.POKER:
            return PRODUCT.POKER;
        default:
            return Product.Casino;
    }
};

export const getUMConfig = async () => {
    const config = getConfig();
    const region = await getRegion();
    const amplitudeApiKey = config.unifiedModules.customConfig?.amplitudeApiKey ?? config.services.amplitudeKey;
    const runtimeOrigin =
        config.sameOriginUnifiedModules && typeof window !== 'undefined' ? window.location.origin : undefined;
    const webEndpoint = runtimeOrigin ?? config.unifiedModules.customConfig?.web;
    const apiEndpoint = runtimeOrigin ?? config.unifiedModules.customConfig?.api;

    const isPoker = process.env.PRODUCT === PRODUCT.POKER;

    const appDomain = {
        product: getProductUM(),
        region: region.toLowerCase(),
        brand: getBrandUM(process.env.BRAND as string),
        ...(isPoker && { theme: PRODUCT.POKER })
    };

    const conf: Config = {
        appDomain,
        clientAuthToken: config.unifiedModules.clientId,
        environment: {
            type: config.unifiedModules.env,
            country: getCountry(process.env.COUNTRY as string),
            ...(webEndpoint && { web: webEndpoint }),
            ...(apiEndpoint && { api: apiEndpoint }),
            ...(amplitudeApiKey && { amplitudeApiKey })
        } as Config['environment']
    };

    return conf;
};
